<template>
  <vs-popup class="add-new-staff-skill" id="popup"
    :title="isCreateMode ? 'ADD SKILL QUALIFICATION' : 'UPDATE SKILL QUALIFICATION'"
    @close="open = false" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-skill-popup" @submit.prevent="handleSubmit(onClickCreateUpdate)" autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="type" name="type" rules="required" v-slot="{ errors }">
                <small class="label">Category</small>
                <v-select :clearable="false" placeholder="" v-model="form.category_id" :options="categories"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'" label="name" :reduce="option => option.id">
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input v-model="form.name" name="name" class="w-full" label="" :danger="!!errors[0]"
                  :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="issuing_organization_name" name="issuing_organization_name" rules="" v-slot="{ errors }">
                <small class="label">Issuing Organization Name</small>
                <vs-input v-model="form.issuing_organization_name" name="issuing_organization_name" class="w-full" label="" :danger="!!errors[0]"
                  :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="requires_renewal" name="requires_renewal" rules="" v-slot="{ errors }">
                <small class="label">Requires Renewal?</small>
                <vs-switch v-model="form.requires_renewal" ></vs-switch>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row" v-if="form.requires_renewal">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="validity_period_months" name="validity_period_months" rules="" v-slot="{ errors }">
                <small class="label">Validity Period Months</small>
                <vs-input v-model="form.validity_period_months" name="validity_period_months" class="w-full" label="" :danger="!!errors[0]"
                  :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="description" name="description" rules="" v-slot="{ errors }">
                <small class="label">Description</small>
                <vs-textarea class="mb-0" v-model="form.description" height="150px" />
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row" v-if="!isCreateMode">
            <div class="w-full vx-col">
              <ValidationProvider vid="is_active" name="is_active" rules="" v-slot="{ errors }">
                <small class="label mb-2">Status</small>
                <span class="flex text-sm">
                  Active
                  <vs-switch class="mx-2" v-model="form.is_active"></vs-switch>
                  Inactive
                </span>
              </ValidationProvider>
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'create-edit-staff-skills'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const SkillQualificationRepository = RepositoryFactory.get('skills');
import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    id: '',
    categories: [],
    form: {
      name: '',
      description: '',
      category_id: '',
      is_active: true,
      issuing_organization_name: '',
      requires_renewal: false,
      validity_period_months: ''
    },
    isCreateMode: true
  }
}

export default {
  name: 'AddNewSkillQualificationPopUp',
  data() {
    return initialState()
  },
  methods: {
    async openPopup(id) {
      try {
        await Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        this.open = true;
        await this.fetchCategoryList()
        if (!!id) {
          this.id = id
          this.isCreateMode = false
          await this.fetchStaffSkillDetails()
        } else {
          this.isCreateMode = true
        }
      } catch (error) {

      }
    },
    async fetchStaffSkillDetails() {
      await this.$vs.loading({
        container: '#create-skill-popup',
        scale: 0.45
      })
      try {
        const { data } = (await SkillQualificationRepository.getSkillQualification(this.id)).data
        this.form = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-skill-popup > .con-vs-loading')
    },
    async fetchCategoryList() {
      await this.$vs.loading({
        container: '#create-skill-popup',
        scale: 0.45
      })
      try {
        const { data } = (await SkillQualificationRepository.getSkillQualificationCategoriesDropdown('Qualification')).data
        this.categories = data.filter(x => !!x.is_active)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-skill-popup > .con-vs-loading')
    },
    async onClickCreateUpdate() {
      const vue = this;
      await this.$vs.loading({
        container: '#create-skill-popup',
        scale: 0.45
      })
      try {
        if (this.isCreateMode) {
          await SkillQualificationRepository.createSkillQualifications(this.form);
          this.showSuccessMessage('Skill added!');
        } else {
          await SkillQualificationRepository.updateSkillQualifications(this.id, this.form);
          this.showSuccessMessage('Skill updated!');
        }
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.$vs.loading.close('#create-skill-popup > .con-vs-loading')
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-skill-popup > .con-vs-loading')
    },
  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.add-new-staff-skill>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 30% !important;
}
</style>
